import { render, staticRenderFns } from "./RequireAddress.vue?vue&type=template&id=67254658&scoped=true&"
import script from "./RequireAddress.vue?vue&type=script&lang=js&"
export * from "./RequireAddress.vue?vue&type=script&lang=js&"
import style0 from "./RequireAddress.vue?vue&type=style&index=0&id=67254658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67254658",
  null
  
)

export default component.exports